module.exports = __webpack_public_path__ + "static/04-6f7e5683dd0b6da326bd53f664e14987.jpg";